// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"LoginForm_loginBtn__8_S1W","forgotPasswordBtn":"LoginForm_forgotPasswordBtn__NWuZ5"};